import { render, staticRenderFns } from "./VendorCard.vue?vue&type=template&id=10aa8b57&"
import script from "./VendorCard.vue?vue&type=script&lang=js&"
export * from "./VendorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports